import React, { useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import './style.css';
import { listener } from '../../../utils/dispatch';

function Modal({ id, children, style, onClose, className = "" }) {

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback((e) => {
    const targetId = e?.detail?.data?.id || e?.detail?.id;
    if (targetId && targetId !== id) {
      return;
    }
    if (onClose) {
      const result = onClose();
      if (result === false) {
        return;
      }
    }
    setIsModalOpen(false);
  }, [id, onClose]);

  useEffect(() => {
    const unbindOpen = listener('modal' + id, openModal);
    const unbindCloseGlobal = listener('modal-close', closeModal);
    const unbindCloseMui = listener('close-modal', closeModal);
    const unbindCloseNamedPrefix = listener('close-' + id + '-modal', closeModal);
    const unbindCloseNamed = listener('modal-close-' + id, closeModal);

    return () => {
      if (unbindOpen) unbindOpen();
      if (unbindCloseGlobal) unbindCloseGlobal();
      if (unbindCloseMui) unbindCloseMui();
      if (unbindCloseNamedPrefix) unbindCloseNamedPrefix();
      if (unbindCloseNamed) unbindCloseNamed();
    };
  }, [id, openModal, closeModal]);

  if (!isModalOpen) {
    return null;
  }

  const modalContent = (
    <div className="modal" id={id}>
      <div className={`modal-box ${className}`} style={style}>

        <span className="close" onClick={closeModal}>&times;</span>
        <div className='modal-content'>
          {children}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}

export default Modal;
